import {
    LedgerImportToPriceComparisonAddRequest,
    LedgerImportToPriceComparisonDeleteRequest,
    LedgerImportToPriceComparisonEditRequest,
    LedgerImportToPriceComparisonGetRequest,
} from '@dave/types';
import { createAction, props } from '@ngrx/store';
import { UploadActionProps } from '../../guards/resolver.helper';
import { GatewayResponseErrorType } from '../../services/app-gateway.service';
import { LedgerImportToPriceComparisonEntity } from '../../entities/ledger-import-to-price-comparison.entity';


const prefix = 'data/' + 'ledgerImportTiPriceComparison/';
export const LedgerImportToPriceComparisonActionTypes = {
    Load: createAction(prefix + 'load', props<{ Payload: LedgerImportToPriceComparisonGetRequest }>()),
    Change: createAction(prefix + 'change', props<{ Payload: LedgerImportToPriceComparisonEditRequest }>()),
    Delete: createAction(prefix + 'delete', props<{ Payload: LedgerImportToPriceComparisonDeleteRequest }>()),

    // UpdateAll: createAction(prefix + 'updateAll', props<{ Payload: Array<LedgerImportToPriceComparisonEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateMany: createAction(prefix + 'updateMany', props<{ Payload: Array<LedgerImportToPriceComparisonEntity>; updateLatestUpdatedAt?: boolean }>()),
    // UpdateOne: createAction(prefix + 'updateOne', props<{ Payload: LedgerImportToPriceComparisonEntity }>()),
    // RemoveOne: createAction(prefix + 'remove', props<{ Payload: number }>()),

    CreateRequest: createAction(prefix + 'create/request', props<{ Payload: LedgerImportToPriceComparisonAddRequest }>()),
    CreateSuccess: createAction(prefix + 'create/success', props<{ Payload: LedgerImportToPriceComparisonEntity }>()),
    CreateFailure: createAction(prefix + 'create/failure', props<{ Payload: { Errors: GatewayResponseErrorType; ToasterMessage?: string } }>()),
};
